import { useState, useEffect } from 'react';

interface HeaderProps {
  navItems: { label: string; href: string }[];
}

export default function Header({ navItems }: HeaderProps) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-[72px]">
          <a
            href="#hero"
            className="flex items-center gap-2.5 text-xl md:text-2xl font-heading font-bold text-accent-600 hover:text-accent-500 transition-colors whitespace-nowrap"
          >
            <span className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center bg-accent-500 text-background-50 rounded-lg text-sm md:text-base font-bold">蘑</span>
            蘑菇影院
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors whitespace-nowrap ${
                  scrolled
                    ? 'text-foreground-700 hover:text-accent-600 hover:bg-accent-50'
                    : 'text-foreground-800 hover:text-accent-500 hover:bg-foreground-50/10'
                }`}
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="#hero"
              className="px-5 py-2 text-sm font-semibold bg-accent-500 text-background-50 rounded-full hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer"
            >
              开始观看
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 hover:text-accent-600 transition-colors cursor-pointer"
            aria-label="菜单"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60">
          <nav className="flex flex-col px-4 py-3 gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMobileOpen(false)}
                className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-accent-600 hover:bg-accent-50 rounded-lg transition-colors whitespace-nowrap"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#hero"
              onClick={() => setMobileOpen(false)}
              className="mt-2 mx-4 px-5 py-2.5 text-sm font-semibold bg-accent-500 text-background-50 rounded-full text-center hover:bg-accent-600 transition-all whitespace-nowrap"
            >
              开始观看
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}